<template>
  <div class="cmp-booking-templates-booking_templates_sidewindow-tags box-widget selected box-widget-template-tag" style="border:none;">
    <!-- <div class="box-header gray shell--div1">
      <div class="box-header--name">{{ $t('template_tag') }}</div>
    </div> -->
    <div class="box-body box-body-temp-tags">
      <v-list class="template_tags">
        <v-list-group
          v-for="(item, index) in templateTags"
          :key="'k' + componentKeyNumber + index"
          v-model="item.active"
          no-action
          v-bind:style="{ margin: '0' }"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-for="(subItem, index) in item.items"
            :key="'sk' + componentKeyNumber + index"
            :id="'sk' + componentKeyNumber + index"
            @click="onClickTemplateTag( subItem )"
            @mouseover="mouseOverTemplateTag"
            :title="getFullTag( subItem )"
            class="olo o"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                <span draggable="true" @dragstart="e => onDrag(e, getFullTag( subItem ))">{{ getFullTag( subItem ) }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </div>
  </div>
</template>


<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";

export default {
  props: ["templateTags", "componentKeyNumber"],
  data: function() {
    return {};
  },
  computed: {},
  methods: {
    getFullTag(item) {
      return item.noTag ? item.title : "[% ph." + item.title + " %]";
    },
    onClickTemplateTag(item) {
      this.copyToClipboard(this.getFullTag(item));
      NotificationService.showNotification({
        text: "Copied !",
        timeout: 3000,
        color: "info"
      });
    },
    copyToClipboard: function(str) {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendhild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    mouseOverTemplateTag(event) {
      // console.log("m over: ", event.target, event.target.className);
      // if (window.getSelection) {
      //   var selection = window.getSelection();
      //   var rangeToSelect = document.createRange();
      //   rangeToSelect.selectNodeContents(event.target);

      //   selection.removeAllRanges();
      //   selection.addRange(rangeToSelect);
      // }
    },
    onDrag: function (ev, string) {
      ev.dataTransfer.setData("text", string);
    },
  }
};
</script>


<style lang="scss" scoped>
.list {
  margin-top: 0 !important;
}

.box-body-temp-tags {
  display: flex;
  flex-direction: column;
  /* height: 650px; */
  height: calc(100vh - 290px);
  overflow-y: auto;
}

.template_tags  .list__group__items .list__tile {
  font-size: 12px;
  height: 22px;
  padding-left: 30px;
}

.template_tags .list__group__header .list__tile {
  height: 30px;
  font-size: 13px;
}
</style>

<style lang="scss">
.cmp-booking-templates-booking_templates_sidewindow-tags {
  .template_tags {

    .list__group__header {
      .list__tile {
        height: 40px;
      }
    }

    .list__tile {
      font-size: 13px;
    }

    .list__group__items {
      .list__tile {
        height: 30px;
        padding-left: 30px;
      }
    }
  }
}
</style>